(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("8EjPM", function(module, exports) {
var $64c171c90fd11782$var$productsSections = document.querySelectorAll(".s-products");
$64c171c90fd11782$var$productsSections.forEach(function(section) {
    var items = section.querySelectorAll(".g-products .i-product");
    var loadMoreButton = section.querySelector(".--js-products-load-more");
    var paginationActiveItemsNumber = section.querySelector(".i-pagination__active-items");
    var currentUrl = new URL(window.location.href);
    var scrollYValue = currentUrl.searchParams.get("y") ? Number(currentUrl.searchParams.get("y")) : 0;
    var getParamsHandler = function() {
        var _a;
        if (!loadMoreButton) return;
        var listingProductsNumber = Number(currentUrl.searchParams.get("limit"));
        var onloadActiveItemsNumber = Number(loadMoreButton.dataset.activeItemsNumber);
        var totalItemsNumber = Number(loadMoreButton.dataset.totalItemsNumber);
        if (!paginationActiveItemsNumber || !listingProductsNumber || listingProductsNumber <= onloadActiveItemsNumber) return;
        if (listingProductsNumber >= totalItemsNumber) {
            listingProductsNumber = totalItemsNumber;
            currentUrl.searchParams.set("limit", "".concat(totalItemsNumber.toString()));
            window.history.pushState({}, "", currentUrl.toString());
            loadMoreButton.remove();
        }
        paginationActiveItemsNumber.innerHTML = listingProductsNumber.toString();
        if (loadMoreButton) loadMoreButton.dataset.activeItemsNumber = listingProductsNumber.toString();
        if (listingProductsNumber <= totalItemsNumber) {
            for(var i = 0; i < listingProductsNumber; i++)if (items[i] || items[i].classList.contains("--hidden")) (_a = items[i]) === null || _a === void 0 || _a.classList.remove("--hidden");
        }
        if (scrollYValue > 0) window.scrollTo(0, scrollYValue);
        else section.scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };
    if (currentUrl.searchParams.has("limit")) getParamsHandler();
    loadMoreButton === null || loadMoreButton === void 0 || loadMoreButton.addEventListener("click", function(e) {
        var _a;
        e.preventDefault();
        var activeItemsNumber = Number(loadMoreButton.dataset.activeItemsNumber);
        var activeItemsStepNumber = Number(loadMoreButton.dataset.activeItemsStepNumber);
        var totalItemsNumber = Number(loadMoreButton.dataset.totalItemsNumber);
        var itemsNumber = activeItemsNumber + activeItemsStepNumber < totalItemsNumber ? activeItemsNumber + activeItemsStepNumber : totalItemsNumber;
        loadMoreButton.dataset.activeItemsNumber = itemsNumber.toString();
        if (paginationActiveItemsNumber) paginationActiveItemsNumber.innerHTML = itemsNumber.toString();
        currentUrl.searchParams.set("limit", "".concat(itemsNumber.toString()));
        if (itemsNumber >= totalItemsNumber) loadMoreButton.remove();
        for(var i = activeItemsNumber; i < itemsNumber; i++)(_a = items[i]) === null || _a === void 0 || _a.classList.remove("--hidden");
    });
    window.addEventListener("beforeunload", function() {
        scrollYValue = window.scrollY;
        if (scrollYValue > 100) currentUrl.searchParams.set("y", "".concat(scrollYValue));
        window.history.replaceState({}, "", currentUrl.toString());
    });
});

});

})();
//# sourceMappingURL=products-handle.3f69690e.js.map
